// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"b647b6cb","572":"1903324d"}[chunkId] + ".chunk.js";
};